<template>
    <div>退出登录</div>
</template>

<style></style>

<script>
import axios from 'axios';
import { BaseUrl } from '@/http/config.js'

export default {
    mounted() {
        this.$api.A_Park.loginOut(null, [null, null]).then(res => {
            if (res.code == 0) {
                this.$Local.removeLocal(["user", "role", "bindCompanies"]);
                window.sessionStorage.clear();
                this.$router.push("/");
            }
        });
    },
};
</script>